import { render, staticRenderFns } from "./CustomerRewardTableViewForm.vue?vue&type=template&id=5a4a6792&"
import script from "./CustomerRewardTableViewForm.vue?vue&type=script&lang=js&"
export * from "./CustomerRewardTableViewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports